export const EnergyWeigthCoefValue = 71;
export const EnergyKjKcalCoef = 4.186;
export const DefaultWeight = 100;
export const PlanEnergy = 2770;